import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IGetReportCargosUseCase } from "../../../presentation/useCases/read/get_report_cargos_use_case";
import { ReportData } from "../../models/report_data";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

import dayjs from "dayjs";

/**
 * GetReportCargosUseCase
 */

export class GetReportCargosUseCase implements IGetReportCargosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportCargos(
    requiredMimeType: ReportMimeType | null,
    idCargo?: number,
  ): Promise<ReportData> {
    const response = await this.repository.getRelatorioCargos(requiredMimeType, idCargo ?? null);

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = idCargo === null
        ? `cargos_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`
        : `cargo_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }
    return response;
  }
}
